/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Lot_Option_Created_AtInputs */

const vi_lot_option_created_at = /** @type {(inputs: Lot_Option_Created_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tạo: ${i?.time}`)
};

/**

* @param {Lot_Option_Created_AtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_option_created_at = /** @type {((inputs: Lot_Option_Created_AtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Option_Created_AtInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_option_created_at(inputs)
});